import Vue from "vue";
import store from "./store.js";
import Router from "vue-router";

import Language from "./components/Language.vue";
import NotFound from "./components/404.vue";

import Home from "./components/Home.vue";

import Announcements from "./components/Announcements.vue";
import AnnouncementList from "./views/announcements/AnnouncementList.vue";
import AnnouncementID from "./views/announcements/AnnouncementID.vue";

import Sezenden from "./components/Sezenden.vue";
import SezendenList from "./views/sezenden/SezendenList.vue";
import SezendenID from "./views/sezenden/SezendenID.vue";

import Press from "./components/Press.vue";
import PressList from "./views/press/PressList.vue";

import AllWorks from "./components/AllWorks.vue";
import HomePanel from "./views/all_works/HomePanel.vue";
import Discography from "./views/all_works/Discography.vue";
import Biography from "./views/all_works/Biography.vue";
import Albums from "./views/all_works/albums/Albums.vue";
import AlbumsList from "./views/all_works/albums/AlbumList.vue";
import AlbumID from "./views/all_works/albums/AlbumID.vue";
import AllWorks_Songs from "./views/all_works/Works.vue";
import Publications from "./views/all_works/Publications.vue";
import DVD from "./views/all_works/Dvd.vue";
import Products from "./views/all_works/Products.vue";

import Videos from "./components/Videos.vue";
import VideosList from "./views/videos/VideosList.vue";
import VideosID from "./views/videos/VideosID.vue";

import PhotoGalleries from "./components/Photos.vue";
import PhotoGalleriesList from "./views/photos/PhotosList.vue";

import Contact from "./components/Contact.vue";
import Updates from "./components/Updates.vue";

Vue.use(Router);

const check = /tr/gi;
const lng = check.test(navigator.language) ? "tr" : "en";
var currentYear = new Date().getFullYear();

export default new Router({
  mode: "history",
  routes: [
    {
      path: "", // if empty parameter
      redirect: lng, // redirect to lng '/tr' or '/en'
    },

    {
      path: "*", // not found page
      redirect: `/${lng}/404`,
    },
    {
      path: "/:lang",
      component: Language,
      children: [
        // 404
        {
          path: "404",
          component: NotFound,
        },
        // HOME
        {
          name: "home",
          path: "",
          component: Home,
          beforeEnter(to, from, next) {
            if (to.params.lang === "tr" || to.params.lang === "en") {
              next();
            } else {
              next(`/${lng}`);
            }
          },
        },
        // ANOUNCEMENT router
        {
          path: "announcements",
          component: Announcements,
          beforeEnter(to, from, next) {
            if (!to.params.type) {
              next(`${to.path}/actual/${currentYear}`);
            } else if (to.params.type === "archive" && !to.params.year) {
              next(`${to.path}/${currentYear - 1}`);
            }
            next();
          },
          children: [
            {
              path: ":type",
              components: {
                default: AnnouncementList,
                id: undefined,
              },
              beforeEnter(to, from, next) {
                // check params
                if (
                  to.params.type === "actual" ||
                  to.params.type === "archive"
                ) {
                  return to.params.type === "archive"
                    ? next(`${to.path}/${currentYear - 1}`)
                    : next();
                } else {
                  return next("/404");
                }
              },
            },
            {
              path: ":type/:year",
              components: {
                default: AnnouncementList,
                id: undefined,
              },
              beforeEnter(to, from, next) {
                // check params
                if (
                  to.params.type === "actual" ||
                  to.params.type === "archive"
                ) {
                  next();
                } else {
                  next("/404");
                }
              },
            },
            {
              path: ":type/:year/:id",
              components: {
                default: undefined,
                id: AnnouncementID,
              },
              beforeEnter(to, from, next) {
                // check params
                if (
                  to.params.type === "actual" ||
                  to.params.type === "archive"
                ) {
                  next();
                } else {
                  next("/404");
                }
              },
            },
          ],
        },
        // SEZENDEN
        {
          path: "sezenden",
          component: Sezenden,
          children: [
            {
              path: "",
              components: {
                default: SezendenList,
                id: undefined,
              },
            },
            {
              path: ":id",
              components: {
                default: undefined,
                id: SezendenID,
              },
            },
          ],
        },
        // PRESS
        {
          path: "press",
          component: Press,
          beforeEnter(to, from, next) {
            const link =
              to.params.lang === "tr"
                ? "foreign_press_clippings"
                : "press_clippings";
            const query = store.state.press_dates_list[link].sort((a, b) => {
              return b.to - a.to;
            })[0];
            if (!to.params.type) {
              next(
                `${to.path}/${link}/${query.from}_${query.to ? query.to : ""}`
              );
            }
            next();
          },
          children: [
            {
              path: ":type",
              component: PressList,
              beforeEnter(to, from, next) {
                if (
                  (!to.params.fromTo && to.params.type !== "photo_novels") ||
                  (!to.params.fromTo && to.params.type !== "print_publications")
                ) {
                  let path = `${to.path}${!to.path.endsWith("/") ? "/" : ""}${
                    store.state.press_dates_list[to.params.type][0].from
                  }_${
                    store.state.press_dates_list[to.params.type][0].to
                      ? store.state.press_dates_list[to.params.type][0].to
                      : ""
                  }`;
                  next(path);
                } else {
                  next(`${to.path}/2000_${new Date().getFullYear()}`);
                }
              },
            },
            {
              path: ":type/:fromTo",
              component: PressList,
            },
            {
              path: ":type/:fromTo/:id",
              component: PressList,
            },
          ],
        },
        // ALL WORKS
        {
          path: "all_works",
          component: AllWorks,
          children: [
            {
              path: "",
              component: HomePanel,
            },
            {
              path: "discography",
              component: Discography,
            },
            {
              path: "biography",
              component: Biography,
            },
            {
              path: "albums_list",
              component: Albums,
              beforeEnter(to, from, next) {
                if (!to.params.type) {
                  next(to.path + "/albums");
                }
                next();
              },
              children: [
                {
                  path: ":type",
                  components: {
                    default: AlbumsList,
                    album_item: undefined,
                  },
                  beforeEnter(to, from, next) {
                    const regex = /(collaborations)|(compilations)|(singles_45rpms)|(singles)|(albums)|(soundtrack)/;
                    if (regex.test(to.params.type)) {
                      next();
                    } else {
                      next("/404");
                    }
                  },
                },
                {
                  path: ":type/:id",
                  components: {
                    default: undefined,
                    album_item: AlbumID,
                  },
                  beforeEnter(to, from, next) {
                    const regex = /(collaborations)|(compilations)|(singles_45rpms)|(singles)|(albums)|(soundtrack)/;
                    if (regex.test(to.params.type)) {
                      next();
                    } else {
                      next("/404");
                    }
                  },
                },
              ],
            },
            {
              path: "works",
              component: AllWorks_Songs,
            },
            {
              path: "books",
              component: Publications,
            },
            {
              path: "dvd",
              component: DVD,
            },
            {
              path: "products",
              component: Products,
            },
          ],
        },
        // VIDEOS
        {
          path: "videos",
          component: Videos,
          beforeEnter(to, from, next) {
            if (!to.params.type) {
              next(`${to.path}/1`);
            }
            next();
          },
          children: [
            {
              path: ":type",
              components: {
                default: VideosList,
                id: undefined,
              },
            },
            {
              path: ":type/:id",
              components: {
                default: VideosList,
                id: VideosID,
              },
            },
          ],
        },
        // PHOTOS
        {
          path: "photo_galleries",
          component: PhotoGalleries,
          beforeEnter(to, from, next) {
            if (!to.params.year) {
              next(`${to.path}/1`);
            }
            next();
          },
          children: [
            {
              path: ":year",
              component: PhotoGalleriesList,
            },
          ],
        },
        // CONTACT
        {
          path: "contact",
          component: Contact,
        },
        // UPDATES
        {
          path: "updates",
          component: Updates,
        },
      ],
    },
  ],
});
